<div class="form-group">
  <select class="select-form-control" [(ngModel)]="selectedOperator"
          value="" (focus)="selectFirst()"
          [class.form-error] = "hasError" id="operatorId"
          (change)= "sendOperatorName()">
    <option *ngFor="let operator of operatorList;let i= index" [ngValue]="operator">{{operator.nameFa}}</option>
  </select>
  <span class="floating-label">اپراتور</span>
  <span *ngIf="!optional" class="star">*</span>
  <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
</div>
